import React from "react";
import { FiUser } from "react-icons/fi";

import Input from "../../../components/Atoms/Input";
import Loading, {
  SPINNER_ON_GOLD,
} from "../../../components/Atoms/Loading";

import { StyledButton } from "./styles";

interface RequestPasswordResetEmailProps {
  isRequesting: boolean;
}

const RequestPasswordResetEmail: React.FC<RequestPasswordResetEmailProps> = ({
  isRequesting = false,
}) => {
  return (
    <>
      <Input
        name="username"
        icon={FiUser}
        placeholder="Digite seu usuário ou email"
        autoComplete="username"
        customWidth="100%"
        enabled={!isRequesting}
      />
      <StyledButton
        type="submit"
        enabled={!isRequesting}
        aria-label={isRequesting ? "Enviando…" : undefined}
        aria-busy={isRequesting}
      >
        {isRequesting ? (
          <Loading size={2} customColors={SPINNER_ON_GOLD} />
        ) : (
          "Enviar"
        )}
      </StyledButton>
    </>
  );
};

export default RequestPasswordResetEmail;
